const StepCard = ({ step, title, status, progress, totalQuestions, onClick }) => {
  const getProgressMessage = () => {
    switch (step) {
      case 2:
        return "Working for Employee";
      // case 3:
      //   return "Working for Employee";
      case 3:
        return "Employee Draft Check";
      case 4:
        return "Employee Draft Check";
      default:
        return "";
    }
  };

  const getStepInstructions = () => {
    switch (step) {
      case 1:
        return "Upload Documents and Review Filled Checklist thereafter";
      case 2:
        return "Tax Return preparation after confirmation of Checklist (step-1)";
      // case 3:
      //   return "Additional information may be required to complete your tax return. Please respond to any requests.";
      case 3:
        return "Review draft tax return and submit Form 8879";
      case 4:
        return "We’ll file your return after confirmation and share the acknowledgement";
      default:
        return "";
    }
  };

  const handleClick = () => {
    if (onClick) { onClick(step); }
  };

  return (
    <div
      className={`tax-filing-step-card ${status}`}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="tax-filing-step-header">
        <h6>Step {step}</h6>
        <span className={`tax-filing-status-indicator ${status}`}>
          {status === "in-progress" ? "IN PROGRESS" : status.toUpperCase()}
        </span>
      </div>
      <h5>{title}</h5>
      {status === "in-progress" && step === 1 && (
        <div className="tax-filing-progress-container">
          <div className="tax-filing-progress-bar">
            <div
              className="tax-filing-progress-fill"
              style={{ width: `${(progress / totalQuestions) * 100}%` }}
            ></div>
          </div>
          <div className="tax-filing-progress-text">{progress}/{totalQuestions} Completed</div>
        </div>
      )}
      {status === "in-progress" && step !== 1 && (
        <div className="tax-filing-message">
          <p>{getProgressMessage()}</p>
        </div>
      )}
      <div className="step-hover-tooltip">
        <div className="tooltip-content">
          {getStepInstructions()}
        </div>
      </div>
    </div>
  );
};

export default StepCard;